import Header from './Header';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';

export default function Layout() {
  const location = useLocation();
  const isCommuntiyPage = location.pathname === '/community';
  
  return (
    <div
      className="min-h-screen flex flex-col text-white"
      style={{
        background: isCommuntiyPage ? 'transparent' : ' #05091B'
      }}
    >
      <Header />
      <main className="grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
